import { Save } from '@mui/icons-material'
import { Box, Button, CircularProgress } from '@mui/material'

import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  disableSubmission: boolean
  loading: boolean
  save: () => void
}

const OrderFooter: React.FC<Props> = ({ disableSubmission, loading, save }) => {
  const { t } = useTranslation()

  return (
    // Pad the full-width Save button off the panel edges (matching the
    // checkout footer's 12/12/14 spacing) so it isn't flush to the LHS/RHS/bottom.
    <Box sx={{ padding: '12px 12px 14px' }}>
      <Button
        color="primary"
        size="small"
        startIcon={<Save />}
        disabled={disableSubmission}
        loading={loading}
        loadingIndicator={<CircularProgress color="inherit" size={16} />}
        onClick={save}
        variant="contained"
        fullWidth
        loadingPosition="start">
        {t('marketplace:save')}
      </Button>
    </Box>
  )
}

export default OrderFooter
